import {
  createConfigOption,
  optionalWithDefault,
  record,
  struct,
} from "./config-option";
import { assetConfig } from "./asset-config-option";
import { ChecksumAddress } from "@silo/types";

export type SiloConfig = ReturnType<(typeof siloConfig)["create"]>;

export const siloConfig = struct({
  name_MUST_SYNCHRONIZE: optionalWithDefault(
    createConfigOption<string | undefined>()
  )(undefined),
  symbol_MUST_SYNCHRONIZE: optionalWithDefault(
    createConfigOption<string | undefined>()
  )(undefined),
  /**
   * If enabled, will subtract the silo's TVL from the total TVL displayed on
   * the markets page (only applies to graph).
   */
  suppressTVL_MUST_SYNCHRONIZE: optionalWithDefault(
    createConfigOption<boolean>()
  )(false),
  frozen: optionalWithDefault(createConfigOption<boolean>())(false),
  assets: optionalWithDefault(record<ChecksumAddress>()(assetConfig))({}),
  /**
   * Some silos receive Curve LP tokens as deposits, and store Convex Wrappers
   * as the actual silo asset. This option identifies those silos, and provides
   * the Curve LP token address
   */
  curveLpTokenAddress_MUST_SYNCHRONIZE: optionalWithDefault(
    createConfigOption<ChecksumAddress | undefined>()
  )(undefined),
});
